// Translation dictionary — English
const en = {
  comum: {
    salvar: 'Save',
    cancelar: 'Cancel',
    excluir: 'Delete',
    deletar: 'Delete',
    editar: 'Edit',
    fechar: 'Close',
    voltar: 'Back',
    confirmar: 'Confirm',
    carregando: 'Loading...',
    salvando: 'Saving...',
    enviando: 'Sending...',
    processando: 'Processing...',
    atualizar: 'Refresh',
    buscar: 'Search',
    sim: 'Yes',
    nao: 'No',
    ok: 'OK',
    erro_generico: 'An error occurred. Please try again.',
    nenhum_resultado: 'No results found',
    obrigatorio: 'Required field',
    opcional: 'optional',
  },

  nav: {
    principal: 'Main',
    dashboard: 'Dashboard',
    campanhas: 'Campaigns',
    contatos: 'Contacts',
    envios: 'Sends',
    metricas: 'Metrics',
    whatsapp: 'WhatsApp',
    configuracoes: 'Settings',
    minha_empresa: 'My company',
    creditos: 'Credits',
    pacotes: 'Packages',
    upgrade_plano: 'Upgrade plan',
    pack_ia: 'AI top-up pack',
    ia_beta: 'AI (Beta)',
    secretaria_ia: 'AI Concierge',
    conversas: 'Conversations',
    configurar_ia: 'Configure AI',
    ia_requer_plano: 'Requires Pro plan or AI Pack. Click to view packages.',
    administracao: 'Administration',
    painel_admin: 'Admin Panel',
    sair: 'Sign out',
    painel: 'Panel',
    abrir_menu: 'Open menu',
    fechar_menu: 'Close menu',
    idioma: 'Language',
  },

  login: {
    marca_sub: 'Your AI Concierge on WhatsApp',
    nav_vantagens: 'Benefits',
    nav_planos: 'Plans',
    nav_entrar: 'Sign in',
    hero_badge: 'AI Concierge that answers your WhatsApp 24/7 — no vacations, no bans',
    hero_titulo_1: 'The patient messages at 10pm, on a Sunday, on a holiday.',
    hero_titulo_destaque: 'Your AI Concierge replies instantly',
    hero_sub: 'Every patient left waiting books at the clinic next door. RIIA\'s AI Concierge answers, handles questions, understands the case and books straight into your calendar on WhatsApp — and reminds them before the appointment and brings back whoever disappeared in. You only step in when the sale is ready to close.',
    hero_cta_gratis: 'Start free',
    hero_cta_planos: 'See plans',
    stat_entrega: 'Delivery rate',
    stat_respostas: 'More replies',
    stat_negocios: 'Businesses served',
    stat_gratis: 'Free to try',
    stat_gratis_valor: '7 days',
    stat_freemium: 'Free Freemium plan',
    stat_freemium_valor: 'Free',
    form_titulo: 'Sign in to your panel',
    form_sub: 'Access your RIIA account',
    form_ja_cliente: 'Already a customer? Sign in with your email and password.',
    form_email: 'Email',
    form_senha: 'Password',
    form_mostrar_senha: 'Show password',
    form_ocultar_senha: 'Hide password',
    form_entrando: 'Signing in...',
    form_entrar: 'Sign in',
    form_sem_conta: "Don't have an account yet?",
    form_ver_planos: 'See the plans',
    form_esqueci_senha: 'Forgot your password?',
    recuperar_titulo: 'Recover password',
    recuperar_descricao: 'Enter your account email. We will send you a link to reset your password.',
    recuperar_enviar: 'Send reset link',
    recuperar_enviando: 'Sending...',
    recuperar_sucesso: 'If the email is registered, you will receive a reset link shortly.',
    recuperar_erro: 'Error requesting password recovery',
    erro_credenciais: 'Invalid email or password',
    erro_conexao: 'No connection to the server. Check your internet.',
    erro_servidor: 'Server unavailable. Please try again shortly.',
    erro_generico: 'Error {status} while signing in',
    vantagens_titulo: 'A concierge that never sleeps, never forgets and never costs a salary',
    vantagens_sub: 'A human receptionist costs R$ 2,000+/month and works 8 hours a day. The AI Concierge works 24/7, every day, with no vacations or severance.',
    vantagens: {
      secretaria_titulo: '24/7 AI Concierge',
      secretaria_texto: 'Replies to every patient in seconds, any time of day. Handles questions, understands the case through your business funnel, books appointments and alerts your team when the patient is ready to close.',
      ia_titulo: 'AI that humanizes',
      ia_texto: 'Each message is rewritten by AI to sound natural and vary between contacts — reduces the risk of blocks.',
      pacing_titulo: 'Human pacing',
      pacing_texto: 'Random intervals between messages and pauses between blocks. Sending respects the rhythm of a real person.',
      janela_titulo: 'Time window',
      janela_texto: 'Set business hours for sending. Pauses automatically at night and resumes from where it stopped the next day.',
      canais_titulo: 'WhatsApp + Email',
      canais_texto: 'One panel, two channels. Create multimedia campaigns (text, image, video, audio, document).',
      tempo_real_titulo: 'Track in real time',
      tempo_real_texto: 'Status dashboard, deliveries, failures and progress for each campaign — refreshed every 15s.',
      import_titulo: 'Easy import',
      import_texto: 'Upload your list via CSV or sync directly from your connected WhatsApp. Automatic groups by size.',
    },
    planos_titulo: 'Simple plans, no fine print',
    planos_sub: 'Start free. Upgrade when you need to. Cancel whenever you want.',
    plano_popular: 'Most popular',
    plano_gratis: 'Free',
    plano_para_sempre: 'forever',
    plano_sob_consulta: 'On request',
    plano_personalizado: 'custom plan',
    planos: {
      freemium_descricao: 'To get to know the platform',
      freemium_cta: 'Create free account',
      freemium_recursos: [
        '1 WhatsApp instance',
        '50 contacts',
        '100 sends/month',
        'No AI Assistant',
        'Email support',
      ],
      starter_descricao: 'For small businesses',
      starter_cta: 'Subscribe to Starter',
      starter_recursos: [
        '1 WhatsApp instance',
        '1,000 contacts',
        '3,000 sends/month',
        'AI message variations',
        'Add-on credits available',
        'Email support',
      ],
      essencial_descricao: 'For growing businesses',
      essencial_cta: 'Subscribe to Essential',
      essencial_recursos: [
        '2 WhatsApp instances',
        '2,000 contacts',
        '4,000 sends/month',
        'AI Assistant — 150 msgs/month',
        'Add-on credits available',
        'Email support',
      ],
      pro_descricao: 'Broadcasting + AI Assistant 24/7',
      pro_cta: 'Subscribe to Professional',
      pro_recursos: [
        '3 WhatsApp instances',
        '3,000 contacts',
        '5,000 sends/month',
        'AI Assistant — 500 msgs/month',
        'Add-on credits available',
        'Priority support',
      ],
      enterprise_descricao: 'For large operations',
      enterprise_cta: 'Talk to sales',
      enterprise_recursos: [
        'On-demand instances and volumes',
        'AI Assistant with expanded quota',
        'Multiple users and teams',
        'Dedicated onboarding + SLA',
        'Dedicated account manager',
      ],
    },
    planos_rodape: '🔒 Secure payment via Stripe · Cancel anytime · No lock-in',
    cta_titulo: 'How many patients will you lose this week?',
    cta_sub: 'Activate your AI Concierge today and reply to every customer in seconds. Start free, no card required.',
    cta_gratis: 'Start free',
    cta_vendas: 'Talk to sales',
    footer_direitos: '© {ano} RIIA · All rights reserved',
    footer_site: 'Official site',
    footer_suporte: 'Support',
    footer_assinar: 'Subscribe',
    whatsapp_vendas_msg: 'Hi! I want to learn more about RIIA.',
  },

  dashboard: {
    titulo: 'Dashboard',
    atualizado_as: 'Updated at {hora}',
    atualizar: 'Refresh',
    card_total: 'Total campaigns',
    card_finalizadas: 'Finished',
    card_andamento: 'In progress',
    card_contatos: 'Active contacts',
    ultimas_campanhas: 'Latest campaigns',
    status_campanhas: 'Campaign status',
    pie_finalizadas: 'Finished',
    pie_andamento: 'In progress',
    pie_erros: 'Errors',
    bar_finalizada: 'Finished',
    nenhuma_campanha: 'No campaigns yet',
  },

  fluxo: {
    titulo: 'Getting started',
    etapas_concluidas: '{feitas} of {total} steps completed',
    trilha_concierge: 'YOUR CONCIERGE — answers, books and follows up',
    trilha_campanhas: 'CAMPAIGNS — bulk notices and promotions',
    c1_label: 'Turn the concierge on',
    c1_desc: 'Enable automatic WhatsApp replies',
    c2_label: 'Tell it who it is',
    c2_desc: 'Name, business and how it should serve',
    c3_label: 'Connect your calendar',
    c3_desc: 'So it books real slots in your system',
    c4_label: 'Service profile',
    c4_desc: 'Tone of voice, emoji and how to address people',
    c5_label: 'Tune reminder timing',
    c5_desc: 'Choose when to warn — the default already warns 1 day and 2h before',
    c6_label: 'Follow up afterwards',
    c6_desc: 'Post-visit, win-back or waiting list',
    fechar_guia: 'Close guide',
    fechar: 'Close',
    step1_label: 'Connect WhatsApp',
    step1_desc: 'Scan the QR Code to connect your number',
    step2_label: 'Sync contacts',
    step2_desc: 'Import contacts from your WhatsApp account',
    step3_label: 'Create groups',
    step3_desc: 'Organize contacts by segment or campaign',
    step4_label: 'Create campaign',
    step4_desc: 'Set up message, intervals and recipients',
    step5_label: 'Start sending',
    step5_desc: 'Activate the send and track progress',
    opcional: 'optional',
    concluido: '✓ Completed',
    fazer_agora: '→ Do it now',
    pendente: 'Pending',
    tudo_pronto: '🎉 All set! Your system is ready to run campaigns.',
  },

  whatsapp: {
    titulo: 'WhatsApp',
    subtitulo: 'Manage your instances and connect numbers via QR Code.',
    atualizar_status: 'Refresh status',
    plano_info: '📱 Plan {plano} — {usadas} of {limite} instance(s) used',
    limite_atingido_sufixo: ' · Limit reached',
    fazer_upgrade: '⬆️ Upgrade',
    upgrade_msg: 'Hi! I want to upgrade my RIIA plan to connect more WhatsApp instances.',
    guia_titulo: '📋 How to connect your WhatsApp:',
    guia_desktop: 'Desktop/laptop:',
    guia_desktop_texto: ' click QR Code, open WhatsApp on your phone → Linked devices → Link a device → scan.',
    guia_celular: 'Phone/tablet:',
    guia_celular_texto: ' open this page on a computer, generate the QR, click 📥 Download QR Code, send the image to yourself (email or WhatsApp) and scan from another device.',
    nova_instancia: 'New instance',
    nova_instancia_placeholder: 'e.g.: chip-sales-01',
    criando: 'Creating...',
    criar: 'Create',
    limite_aviso: '⚠️ Instance limit reached. Upgrade your plan to connect more numbers.',
    qr_titulo: 'Scan the QR Code — {nome}',
    qr_passos: 'WhatsApp → Linked devices → Link a device',
    qr_celular: '📱 On your phone? Download the QR and open it on another device to scan.',
    qr_baixar: '📥 Download QR Code',
    qr_indisponivel: 'QR Code not available — wait or try again',
    qr_auto_atualiza: 'Auto-refreshes every 20s',
    fechar: 'Close',
    col_instancia: 'Instance',
    col_status: 'Status',
    col_acoes: 'Actions',
    status_conectado: 'Connected',
    status_conectando: 'Connecting...',
    status_desconectado: 'Disconnected',
    status_nao_encontrada: 'Not found',
    status_desconhecido: 'Unknown',
    btn_qrcode: '📷 QR Code',
    btn_sincronizar: 'Sync contacts',
    btn_desconectar: 'Disconnect',
    btn_deletar: 'Delete',
    vazio: 'No instances created yet',
    toast_nome_obrigatorio: 'Name is required',
    toast_criada: 'Instance created!',
    toast_erro_criar: 'Error creating instance',
    toast_erro_qr: 'Error fetching QR Code',
    toast_conectado: 'WhatsApp connected! 🎉',
    confirm_desconectar: 'Disconnect "{nome}"?',
    toast_desconectada: 'Instance disconnected',
    toast_erro_desconectar: 'Error disconnecting',
    confirm_deletar: 'Delete instance "{nome}"?',
    toast_deletada: 'Instance deleted',
    toast_erro_deletar: 'Error deleting',
    toast_sincronizando: 'Syncing contacts...',
    toast_sincronizados: '{n} contacts synced!',
    toast_erro_sincronizar: 'Error syncing contacts',
    popup_qr_titulo: 'Instance created! 🎉',
    popup_qr_texto: 'Now connect your WhatsApp by scanning the QR Code. This is the next step to start using the instance "{nome}".',
    popup_qr_botao: '📷 Connect via QR Code',
    popup_qr_depois: 'Later',
    popup_sync_titulo: 'WhatsApp connected! ✅',
    popup_sync_texto: 'To start sending messages, sync your WhatsApp contacts now. You can do this again anytime.',
    popup_sync_botao: 'Sync contacts',
    popup_sync_depois: 'Sync later',
  },

  nova_campanha: {
    titulo: 'New campaign',
    subtitulo: 'Set up message, intervals and contacts before starting the send.',
    step_configurar: 'Configure campaign',
    step_contatos: 'Select contacts',
    nome_campanha_label: 'Campaign name',
    nome_campanha_placeholder: 'e.g.: April Promo',
    tipo_envio_label: 'Send type',
    tipo_whatsapp: '📲 WhatsApp',
    tipo_email: '📧 Email',
    addon_email_hint: '💡 Want to send by email too? Get the add-on for +R$10/month in Settings.',
    instancia_label: 'WhatsApp instance',
    instancia_placeholder: 'sender01',
    instancia_nenhuma: 'No instances registered.',
    instancia_criar_link: 'Create one here',
    midia_checkbox: '📎 Include media (creative)',
    midia_tipo_label: 'Media type',
    midia_tipo_image: '🖼️ Image',
    midia_tipo_video: '🎥 Video',
    midia_tipo_audio: '🎵 Audio',
    midia_tipo_document: '📄 Document',
    midia_origem_upload: '📁 Local file',
    midia_origem_url: '🔗 External URL',
    midia_upload_enviando: '⏳ Uploading...',
    midia_upload_enviado: '✅ {nome}',
    midia_upload_cta: '📁 Click to select a file',
    canva_divider: 'or create on',
    canva_cta: 'Create image on Canva',
    canva_aguardando: 'Waiting for Canva design...',
    canva_passos_1: 'Create or edit your design on Canva',
    canva_passos_2: 'Click Share → Download (PNG or JPG)',
    canva_passos_3: 'Come back and select the downloaded file',
    canva_ja_baixei: 'Done — select file',
    canva_cancelar: 'Cancel',
    chatgpt_cta_imagem: 'Create image with ChatGPT',
    chatgpt_cta_texto: 'ChatGPT',
    chatgpt_cta_texto_title: 'Open ChatGPT in a window to draft/refine the copy and paste it back here',
    chatgpt_aguardando_imagem: 'Waiting for ChatGPT image...',
    chatgpt_aguardando_texto: 'ChatGPT is open — copy the generated text and paste it below',
    chatgpt_passos_1_imagem: 'Ask ChatGPT to create the image',
    chatgpt_passos_2_imagem: 'Download the generated image',
    chatgpt_passos_3_imagem: 'Come back here and select the downloaded file',
    chatgpt_ja_baixei: 'Done — select file',
    chatgpt_cancelar: 'Cancel',
    midia_limite_hint: 'Max size: {max} MB (WhatsApp limit)',
    midia_url_label: 'Media URL',
    midia_url_placeholder: 'https://example.com/image.jpg',
    mensagem_label: 'Message',
    gerar_copy_title_habilitado: 'Generate copy based on the image',
    gerar_copy_title_desabilitado: 'Add an image above to enable',
    gerar_copy_gerando: 'Generating...',
    gerar_copy_btn: 'Generate copy with AI',
    mensagem_placeholder: 'Hi {nome}, we have a special offer for you!',
    mensagem_hint: 'Use {nome}, {telefone} to personalize',
    ia_titulo: '✨ Generate message variations with AI',
    ia_ativo: 'AI creates 5 versions of the message keeping the content, topics, links and CTA — only the style varies. Reduces the risk of blocks.',
    ia_inativo: '⚠️ No variations: the same text will be sent to everyone. A minimum interval of 6s and blocks of 40 contacts / 35s between blocks will be applied to reduce the risk of blocks.',
    email_assunto_label: 'Email subject',
    email_assunto_tooltip: 'Subject line that will appear in the recipient\'s inbox. Use {nome} to personalize.',
    email_assunto_tooltip_exemplo: 'Hi {nome}, check out our special offer!',
    email_assunto_placeholder: 'e.g.: {nome}, we have an exclusive offer for you!',
    email_fallback_label: 'Plain text message (fallback)',
    email_fallback_tooltip: 'Plain text version of the email. Shown in clients that don\'t support HTML.',
    email_fallback_tooltip_exemplo: 'Hi {nome}, check out our offers on our site.',
    email_fallback_placeholder: 'Hi {nome}, check out our offers...',
    email_corpo_label: 'Email body',
    email_corpo_tooltip: 'Visual editor for the email body. Use the toolbar to format text, insert images and links. Switch to HTML mode for advanced editing.',
    email_corpo_tooltip_exemplo: 'Create professional emails without needing to know HTML',
    email_usar_template: '📄 Use template',
    email_hint: 'Use {nome}, {telefone}, {email} to personalize. Click 📁 in the toolbar to upload images.',
    email_preview_label: '📧 Email preview',
    email_preview_de: 'From:',
    email_preview_assunto: 'Subject:',
    email_preview_sem_assunto: '(no subject)',
    intervalo_secao: 'Interval between {canal}',
    intervalo_canal_emails: 'emails',
    intervalo_canal_mensagens: 'messages',
    intervalo_hint_opcional: '(optional — leave blank for immediate sending)',
    intervalo_min_label: 'Minimum (sec)',
    intervalo_min_placeholder: 'e.g.: 15',
    intervalo_descricao_com_valor: 'The interval varies randomly between the minimum entered and {max} (min + 15 s), simulating human behavior.',
    intervalo_descricao_sem_valor: 'The interval varies randomly (min + 15 s), simulating human behavior.',
    blocos_secao: 'Send in blocks',
    blocos_hint_opcional: '(optional — longer pause every N contacts)',
    blocos_tamanho_label: 'Block size',
    blocos_tamanho_placeholder: 'e.g.: 20',
    blocos_intervalo_label: 'Interval between blocks (sec)',
    blocos_intervalo_placeholder: 'e.g.: 300 (5 min)',
    blocos_descricao: 'When set, after every {n} contact(s) the send pauses for {x} second(s) before continuing. Fill in both fields to enable.',
    janela_secao: 'Sending window',
    janela_hint_opcional: '(optional — leave blank to send at any time)',
    janela_hora_inicio_label: 'Start time',
    janela_hora_fim_label: 'End time',
    janela_data_inicio_label: 'Start date',
    janela_dias_label: 'Days of the week (click to select)',
    dia_seg: 'Mon',
    dia_ter: 'Tue',
    dia_qua: 'Wed',
    dia_qui: 'Thu',
    dia_sex: 'Fri',
    dia_sab: 'Sat',
    dia_dom: 'Sun',
    janela_descricao: 'Sending pauses automatically when the end time is reached and resumes the next day from where it stopped. Only sends on the selected days of the week.',
    btn_proximo: 'Next — Select contacts →',
    grupos_label: 'Select by groups',
    filtrar_instancia: 'Filter by instance',
    filtrar_todas: 'All',
    btn_desmarcar_todos: 'Deselect all',
    btn_selecionar_todos: 'Select all',
    btn_desmarcar_instancia: 'Deselect {inst}',
    btn_selecionar_instancia: 'Select {inst}',
    btn_importar_csv: 'Import CSV',
    btn_importando: 'Importing...',
    btn_contato_manual: '+ Manual contact',
    contadores_filtrado: '{sel} of {total} ({inst})',
    contadores_geral: '{sel} of {total} selected',
    csv_hint: '📄 The CSV must have columns: name, phone, email (only phone is required)',
    form_contato_titulo: 'Add contact manually',
    form_contato_nome: 'Name',
    form_contato_telefone: 'Phone',
    form_contato_email: 'Email',
    form_contato_salvar: 'Save and select',
    form_contato_salvando: 'Saving...',
    form_contato_cancelar: 'Cancel',
    importados_titulo: '📥 Contacts imported now ({n}) · {sel} selected',
    importados_desmarcar: 'Deselect all',
    importados_selecionar: 'Select all',
    importados_fechar: 'Close imported list',
    busca_placeholder: 'Search by name or number...',
    vazio_nenhum_contato: 'No contacts registered. Import a CSV or add one manually.',
    vazio_filtro_instancia: 'No contacts in instance "{inst}"',
    vazio_busca: 'No contacts found',
    btn_voltar: '← Back',
    btn_criar_campanha: '🚀 Create campaign with {n} contact(s)',
    btn_criando: 'Creating campaign...',
    toast_csv_importados: '{n} contacts imported!',
    toast_csv_erro: 'Error importing CSV',
    toast_contato_telefone_obrigatorio: 'Phone is required',
    toast_contato_adicionado: 'Contact added!',
    toast_contato_erro: 'Error adding contact',
    toast_sem_contatos: 'Select at least one contact or group',
    toast_midia_url_vazia: 'Enter the media URL or uncheck the option',
    toast_email_sem_assunto: 'Enter the email subject',
    toast_sem_instancia: 'Select a WhatsApp instance before sending',
    toast_instancia_invalida: 'The selected instance does not belong to your account',
    toast_campanha_criada: 'Campaign created! Confirm the start of sending in the list.',
    toast_campanha_erro: 'Error creating campaign',
    toast_midia_enviada: 'File uploaded!',
    toast_midia_erro: 'Error uploading file',
    toast_midia_grande: 'File too large. The limit for {tipo} is {max} MB.',
    toast_copy_gerada: 'Copy generated with AI! Edit as you like.',
    toast_copy_erro: 'Error generating copy. Check that AI is configured.',
    validacao_nome: 'Campaign name is required',
    validacao_mensagem: 'Message is required',
    validacao_email_assunto: 'Email subject is required',
    validacao_email_corpo: 'Enter the email body or the plain text message',
    validacao_intervalo_minimo: 'The minimum interval between messages must be at least 15 seconds',
    filtro_business_secao: 'Account type filter',
    filtro_business_hint: 'select which accounts will receive this campaign',
    filtro_business_label: 'Account type',
    filtro_business_todos: 'All contacts',
    filtro_business_somente_business: 'WhatsApp Business only',
    filtro_business_somente_pessoal: 'Personal accounts only',
    filtro_business_descricao: 'Business accounts belong to companies — lower risk of reporting spam. Account type is detected automatically on contact import.',
    filtro_tags_secao: 'Filter by tag',
    filtro_tags_todos: 'All tags',
    detectar_business_btn: 'Detect Business',
    detectar_business_hint: 'Check the Evolution API for which contacts have a Business account (only those not yet verified)',
    detectar_business_em_andamento: 'Detecting {processados}/{total}…',
    detectar_business_iniciado: 'Detection started for {total} contacts — please wait…',
    detectar_business_concluido: 'Detection complete: {atualizados}/{total} contacts updated',
    detectar_business_nada_fazer: 'All contacts have already been verified',
    detectar_business_erro: 'Detection failed: {erro}',
    validacao_blocos_sem_ia: 'Without AI variations: configure block sending (size and interval) to reduce the risk of blocks',
  },

  campanhas: {
    titulo: 'Campaigns',
    subtitulo: 'Create, monitor and resend campaigns with pause, interval and block control.',
    btn_nova: 'New campaign',
    col_nome: 'Name',
    col_status: 'Status',
    col_horario: 'Time',
    col_intervalo: 'Interval',
    col_criada_em: 'Created on',
    col_acoes: 'Actions',
    badge_nova: 'New',
    status_finalizado: 'Finished',
    status_pendente: 'Pending',
    status_processando: 'Processing',
    status_pausada: 'Paused',
    status_sem_instancia: 'No instance',
    status_aguardando_horario: 'Outside hours',
    status_limite_diario: 'Daily limit',
    status_bloqueio_detectado: 'Check chip',
    status_plano_vencido: 'Plan expired',
    status_erro: 'Error',
    tooltip_limite_diario: 'The daily sending limit for this instance has been reached. The campaign will resume automatically tomorrow.',
    tooltip_bloqueio: 'We detected 3 or more failures in a row — the chip may be restricted by WhatsApp. Check the connected WhatsApp and click Reactivate when everything is OK.',
    tooltip_sem_instancia: 'The WhatsApp for this campaign is disconnected. Reconnect the chip in Menu → WhatsApp.',
    tooltip_aguardando_horario: 'The campaign is outside the configured time window. It will resume automatically at the next start time.',
    intervalo_imediato: 'Immediate',
    btn_iniciar_envio: 'Start sending',
    btn_pausar: 'Pause',
    btn_retomar: 'Resume',
    btn_reativar: 'Reactivate',
    btn_reenviar: 'Resend',
    btn_deletar: 'Delete',
    vazio: 'No campaigns created yet',
    detalhe_titulo: '{nome}',
    detalhe_status: 'Status',
    detalhe_tipo: 'Type',
    detalhe_instancia: 'Instance',
    detalhe_intervalo: 'Interval',
    detalhe_bloco: 'Block',
    detalhe_bloco_valor: '{tamanho} contacts · pause {intervalo}s',
    detalhe_horario: 'Time',
    detalhe_progresso: 'Progress',
    detalhe_progresso_valor: '{n} sent',
    detalhe_mensagem: 'Message',
    detalhe_contatos: 'Linked contacts ({n})',
    reenvio_titulo: 'Resend — {nome}',
    reenvio_hint: 'Leave blank to resend to the same contacts as the original campaign, or select a new list below.',
    reenvio_instancia_label: '📲 WhatsApp instance',
    reenvio_grupos_label: 'Select groups',
    reenvio_grupos_selecionados: '· {n} selected',
    reenvio_desmarcar_todos: 'Deselect all',
    reenvio_selecionar_todos: 'Select all',
    reenvio_importar_csv: 'Import new list (CSV)',
    reenvio_importando: 'Importing...',
    reenvio_contadores: '{sel} / {total} selected',
    reenvio_importados_titulo: '📥 Imported now ({n}) · {sel} selected',
    reenvio_selecionar_contatos: 'Select contacts',
    reenvio_busca_placeholder: 'Search by name or phone...',
    reenvio_vazio: 'No contacts found',
    reenvio_cancelar: 'Cancel',
    reenvio_btn: '🚀 Resend campaign',
    confirmar_inicio_titulo: 'Confirm start of send',
    confirmar_inicio_descricao: 'You are about to start sending the campaign',
    confirmar_aviso_titulo: '⚠️ Important notice',
    confirmar_aviso_texto: 'Mass sending on WhatsApp may cause restrictions, temporary blocks or permanent bans of the number used. Use intervals between messages, reasonable time windows, and only send to contacts who expect to hear from you. You are solely responsible for using the tool and for the consequences of the send.',
    confirmar_aceitar_termos: 'I have read and accept the terms. I understand that mass sending may lead to restrictions or a ban on my WhatsApp and I take responsibility for the send.',
    confirmar_cancelar: 'Cancel',
    confirmar_iniciando: 'Starting...',
    confirmar_btn_iniciar: '🚀 Start sending',
    toast_pausada: 'Campaign paused',
    toast_erro_pausar: 'Error pausing',
    toast_retomada: 'Campaign resumed',
    toast_erro_retomar: 'Error resuming',
    toast_reativada: 'Campaign reactivated! It will be processed shortly.',
    toast_erro_reativar: 'Error reactivating',
    confirm_deletar: 'Delete campaign "{nome}"?',
    toast_deletada: 'Campaign deleted',
    toast_erro_deletar: 'Error deleting',
    toast_erro_detalhe: 'Error loading details',
    toast_reenviada: 'Campaign resent!',
    toast_erro_reenviar: 'Error resending campaign',
    toast_csv_importados: '{n} contacts imported!',
    toast_csv_erro: 'Error importing CSV',
    toast_iniciado: 'Sending started!',
    toast_erro_iniciar: 'Error starting send',
  },

  contatos: {
    titulo: 'Contacts',
    subtitulo_filtrado: '({filtrado} of {total})',
    subtitulo: '({total})',
    pagina_sub: 'Manage contacts and groups organized by WhatsApp instance.',
    btn_remover_dup: 'Remove duplicates',
    btn_limpar_invalidos: 'Clean invalid',
    btn_excluir_sel: 'Delete selected ({n})',
    btn_novo: 'New contact',
    form_titulo: 'New contact',
    col_nome: 'Name',
    col_telefone: 'Phone',
    col_email: 'Email',
    col_instancia: 'Instance',
    col_ia: 'AI Concierge',
    col_cadastrado: 'Registered on',
    col_acoes: 'Actions',
    ia_ativar_title: 'Enable AI Concierge for this contact',
    ia_desativar_title: 'Disable AI Concierge for this contact',
    toast_ia_ativada: 'AI Concierge enabled for the contact',
    toast_ia_desativada: 'AI Concierge disabled for the contact',
    toast_erro_ia: "Error changing the contact's AI Concierge",
    todas_instancias: 'All instances',
    placeholder_telefone: '5561999999999',
    btn_salvar: 'Save contact',
    toast_telefone_obrigatorio: 'Phone is required',
    toast_adicionado: 'Contact added!',
    toast_erro_adicionar: 'Error adding contact',
    toast_atualizado: 'Contact updated!',
    toast_erro_atualizar: 'Error updating contact',
    confirm_remover: 'Remove contact "{nome}"?',
    toast_removido: 'Contact removed!',
    toast_erro_remover: 'Error removing contact',
    confirm_limpar_lids: 'Remove contacts with invalid phone numbers (WhatsApp LIDs and out-of-pattern numbers)? They will be hidden but kept in history.',
    toast_lids_removidos: '{n} invalid contact(s) removed',
    toast_nenhum_invalido: 'No invalid contacts found',
    toast_erro_limpar: 'Error cleaning contacts',
    confirm_dedup: 'Remove duplicate entries for the same phone number? The most complete record will be kept.',
    toast_dup_removidos: '{n} duplicate(s) removed',
    toast_nenhum_dup: 'No duplicates found',
    toast_erro_dedup: 'Error removing duplicates',
    toast_csv_nenhum: 'No contacts were imported. Check that the spreadsheet has a phone column.',
    toast_csv_reativados: '{n} contact(s) were deactivated and were reactivated by this file.',
    toast_csv_timeout: 'The import took longer than expected and the browser stopped waiting. The contacts may have been saved anyway — refresh the list before trying again.',
    toast_csv_rede: 'Could not reach the server to import. Check your connection and try again.',
    import_instancia_label: 'Import into:',
    import_instancia_nenhuma: 'No instance',
    import_instancia_hint: 'Optional — groups the imported contacts under an instance. It does not change which number the campaign sends from.',
    toast_csv_importados_instancia: '{n} contact(s) imported into {instancia}',
    toast_csv_truncados: '{n} contact(s) were NOT imported: your plan allows {limite}. Upgrade or buy credits.',
    toast_csv_sem_telefone: '{n} row(s) had no phone number and were skipped.',
    confirm_excluir_massa: 'Remove {n} selected contact(s)?',
    toast_excluidos: '{n} contact(s) removed!',
    toast_erro_excluir_massa: 'Error removing {n} contact(s)',
    vazio_instancia: 'No contacts for "{inst}". Sync via the WhatsApp panel.',
    vazio: 'No contacts registered yet',
    grupos_titulo: 'Groups',
    grupos_gerar_auto: 'Auto-generate',
    grupos_com_sel: '+ Group with {n} selected',
    grupos_novo: 'New group',
    grupos_auto_titulo: '⚡ Auto-generate groups',
    grupos_auto_sub: 'Splits contacts into groups of N each, respecting the selected instance.',
    grupos_instancia_label: 'Instance',
    grupos_instancia_todas: 'All instances ({n} contacts)',
    grupos_tamanho_label: 'Contacts per group',
    grupos_prefixo_label: 'Name prefix',
    grupos_resultado: 'Result: ~{grupos} groups of {tam} contacts ({total} total)',
    grupos_gerando: 'Generating...',
    grupos_gerar_btn: 'Generate {n} groups',
    grupos_vazio_instancia: 'No groups for instance "{inst}".',
    grupos_vazio: 'No groups created. Create one to organize your contacts.',
    modal_grupo_titulo: 'New group',
    modal_nome_label: 'Group name',
    modal_nome_placeholder: 'e.g.: Returning patients',
    modal_descricao_label: 'Description',
    modal_descricao_placeholder: 'e.g.: March campaign',
    modal_instancia_label: 'Instance',
    modal_instancia_todas: '— all —',
    modal_contatos_label: 'Contacts ({n} selected)',
    modal_buscar: 'Search...',
    modal_criar_btn: 'Create group ({n})',
    modal_criar_btn_sem: 'Create group',
    modal_nome_obrigatorio: 'Group name is required',
    modal_criado: 'Group created! {n} contact(s) added.',
    modal_criado_sem: 'Group created!',
    modal_erro_criar: 'Error creating group',
    grupo_salvar: 'Save ({n})',
    grupo_salvando: 'Saving...',
    grupo_atualizado: 'Group updated!',
    grupo_erro_salvar: 'Error saving group',
    confirm_excluir_grupo: 'Delete group "{nome}"? Contacts will not be removed.',
    toast_grupo_excluido: 'Group deleted!',
    toast_erro_excluir_grupo: 'Error deleting group',
    buscar_contato: 'Search contact...',
    nenhum_contato: 'No contacts',
    selecionar_todos: 'Select all visible',
    col_tags: 'Tags',
    tags_placeholder: 'vip, follow-up, patient',
    tags_hint: 'Separate by comma. E.g.: vip, follow-up',
    todas_tags: 'All tags',
    toast_atualizado_tags: 'Tags updated!',
  },

  grupos: {
    titulo: 'Groups',
    subtitulo: '({n})',
    pagina_sub: 'Organize contacts into manual or auto-generated groups.',
    btn_gerar_auto: 'Auto-generate',
    btn_novo: 'New group',
    aviso_ban: '⚠️ Sending to many groups simultaneously may result in a ban or restriction by WhatsApp. Use with moderation.',
    auto_titulo: '⚡ Auto-generate groups',
    auto_sub: 'Splits all {n} contacts into groups of N contacts each.',
    tamanho_label: 'Contacts per group',
    prefixo_label: 'Name prefix',
    resultado: 'Result: ~{grupos} groups of {tam} contacts',
    gerando: 'Generating...',
    gerar_btn: 'Generate {n} groups',
    form_titulo: 'New manual group',
    form_nome_label: 'Group name',
    form_nome_placeholder: 'e.g.: Returning patients',
    form_instancia_label: 'Instance',
    form_instancia_todas: 'All',
    form_descricao_label: 'Description',
    form_descricao_placeholder: 'Optional',
    form_contatos_label: 'Contacts ({sel} selected of {total})',
    form_limpar: 'Clear selection',
    form_buscar: 'Search by name or phone...',
    form_nenhum_contato: 'No contacts imported',
    form_nenhum_instancia: 'No contacts in this instance',
    form_criando: 'Creating...',
    form_criar: 'Create group',
    col_nome: 'Name',
    col_descricao: 'Description',
    col_contatos: 'Contacts',
    col_criado: 'Created on',
    badge_contatos: '{n} contacts',
    gerenciar_label: 'Manage contacts — {nome}',
    gerenciar_sel: '{n} selected',
    buscar_contato: 'Search contact...',
    nenhum_contato: 'No contacts',
    salvando: 'Saving...',
    salvar: 'Save',
    vazio: 'No groups created yet',
    toast_nome_obrigatorio: 'Name is required',
    toast_criado: 'Group created!',
    toast_erro_criar: 'Error creating group',
    toast_gerados: '{n} groups generated!',
    toast_erro_gerar: 'Error generating groups',
    confirm_deletar: 'Delete group "{nome}"?',
    toast_deletado: 'Group deleted',
    toast_erro_deletar: 'Error deleting group',
    toast_atualizados: 'Contacts updated',
    toast_erro_salvar: 'Error saving',
  },

  envios: {
    titulo: 'Sends',
    atualizado_as: 'Updated at {hora}',
    btn_atualizar: 'Refresh',
    btn_exportar_csv: 'Export CSV',
    selecionar_campanha: 'Select campaign',
    selecione_opcao: 'Select a campaign...',
    contagem: '{n} send(s) found',
    col_contato: 'Contact',
    col_telefone: 'Phone',
    col_status: 'Status',
    col_mensagem: 'Message sent',
    col_data: 'Date',
    vazio: 'No sends found for this campaign',
  },

  metricas: {
    titulo: 'Campaign metrics',
    subtitulo: 'Delivery rate, hourly distribution and top errors per campaign.',
    selecionar_campanha: 'Select campaign',
    selecione_opcao: 'Select a campaign...',
    btn_atualizar: 'Refresh',
    carregando: 'Loading metrics...',
    sem_dados: 'No data for this campaign yet.',
    sem_erros: 'No errors logged.',
    kpi_total: 'Total',
    kpi_enviados: 'Sent',
    kpi_erros: 'Errors',
    kpi_pendentes: 'Pending',
    kpi_taxa: 'Delivery rate',
    kpi_tentativas: 'Avg. attempts',
    grafico_status: 'Status distribution',
    grafico_hora: 'Sends per hour of the day',
    top_erros_titulo: 'Top errors',
    col_erro: 'Error message',
    col_ocorrencias: 'Occurrences',
    status_enviado: 'Sent',
    status_erro: 'Error',
    status_pendente: 'Pending',
  },

  configuracoes: {
    titulo: 'Settings',
    subtitulo: 'Manage access, integrations and email sends.',
    salvando: 'Saving...',
    btn_salvar: 'Save',
    sec_senha: 'Change password',
    label_senha_atual: 'Current password',
    label_nova_senha: 'New password',
    label_confirmar_senha: 'Confirm new password',
    btn_alterar_senha: 'Change password',
    toast_campos_obrigatorios: 'Fill in all fields',
    toast_senhas_nao_conferem: 'Passwords do not match',
    toast_senha_curta: 'New password must be at least 6 characters',
    toast_senha_alterada: 'Password changed successfully!',
    toast_erro_senha: 'Error changing password',
    sec_email: 'Change email',
    email_atual_label: 'Current email:',
    label_novo_email: 'New email',
    label_confirmar_senha_email: 'Confirm your password',
    warn_email: '⚠️ After changing your email, you will need to sign in again.',
    btn_alterar_email: 'Change email',
    toast_email_alterado: 'Email changed! Sign in again.',
    toast_erro_email: 'Error changing email',
    sec_push: 'Push notifications',
    push_sem_suporte: 'Your browser does not support push notifications. Use Chrome, Edge or Firefox.',
    push_bloqueado: '⚠️ You have blocked notifications for this site. Re-enable them in your browser settings (click the lock icon next to the URL) and refresh the page.',
    push_descricao: 'Get alerts on your device when a campaign finishes or when a WhatsApp instance disconnects — works even with the panel closed.',
    push_ativo: '✅ Notifications enabled on this device.',
    btn_teste_push: 'Send test',
    btn_desativar_push: 'Disable',
    btn_ativar_push: 'Enable notifications on this device',
    btn_ativando_push: 'Enabling...',
    toast_push_ativado: 'Notifications enabled! 🔔',
    toast_push_desativado: 'Notifications disabled',
    toast_push_erro_desativar: 'Error disabling',
    toast_push_teste: 'Test sent! Check the notification.',
    toast_push_erro_teste: 'Error sending test',
    sec_whatsapp: '📲 Evolution API (WhatsApp)',
    label_url_api: 'API URL',
    label_api_key: 'API Key',
    toast_config_salvas: 'Settings saved!',
    toast_erro_salvar: 'Error saving',
    sec_openai: '🤖 OpenAI',
    openai_warn: '⚠️ Required for AI message variations. Without the key, local variations are used.',
    sec_blacklist: 'Blacklist — contacts who requested removal',
    blacklist_todas: 'All ({n})',
    blacklist_vazio: '✅ No contacts in blacklist',
    blacklist_vazio_instancia: '✅ No contacts in the blacklist for instance "{instancia}".',
    blacklist_bloqueado_em: 'Blocked on {data}',
    toast_blacklist_removido: 'Contact removed from blacklist',
    toast_blacklist_erro: 'Error removing from blacklist',
    sec_cap: 'Warm-up and daily cap per instance',
    cap_col_instancia: 'Instance',
    cap_col_empresa: 'Company',
    cap_col_dias: 'Days of use',
    cap_col_cap_auto: 'Automatic cap',
    cap_col_override: 'Manual override',
    cap_col_enviados: 'Sent today',
    cap_aquecendo: 'Day {dia} (warming up)',
    cap_dias: '{n} days',
    cap_por_dia: '{n}/day',
    cap_placeholder: 'Auto',
    toast_cap_atualizado: 'Cap updated',
    toast_cap_erro: 'Error saving cap',
    sec_garantia: '7-day guarantee',
    garantia_reembolso_solicitado: '✅ Your refund request has been received. We will contact you within 24 hours to process the cancellation.',
    garantia_texto: 'You are within the 7-day guarantee period. If you are not satisfied, you can request a full refund and we will cancel your account no questions asked.',
    garantia_prazo: 'Time remaining: {dias} day(s).',
    btn_solicitar_reembolso: '↩ Request refund',
    btn_enviando: 'Sending...',
    toast_reembolso_enviado: 'Request sent! We will contact you within 24h.',
    toast_reembolso_erro: 'Error requesting refund. Please try again.',
    confirm_reembolso: 'Are you sure you want to request a refund? Your account will be canceled after processing.',
    sec_smtp: '📧 Email Sending (SMTP)',
    smtp_ativo: '✅ Email add-on active — configure your SMTP server below',
    smtp_where: '📖 Where to find your SMTP details? Check your email provider settings:',
    label_smtp_host: 'SMTP host',
    label_smtp_porta: 'Port',
    label_smtp_from: 'Sender email',
    label_smtp_user: 'Username',
    label_smtp_pass: 'Password',
    btn_salvar_smtp: 'Save email settings',
    addon_titulo: 'Add the email sending module to your plan',
    addon_descricao: 'Send campaigns by email in addition to WhatsApp. Configure your own SMTP server.',
    addon_periodo: '/month',
    btn_contratar_addon: '💳 Get email add-on',
    btn_processando: 'Processing...',
    addon_rodape: 'Secure payment via Stripe · Activated immediately after confirmation',
    toast_addon_ativado: 'Email add-on activated successfully! 🎉',
    toast_addon_erro: 'Error activating add-on. Please contact support.',
    toast_addon_contratar_erro: 'Processing error. Please try again.',
  },

  redefinir: {
    titulo: 'Reset password',
    subtitulo: 'Choose a new password for your account',
    label_nova_senha: 'New password',
    label_confirmar: 'Confirm password',
    btn_salvar: 'Reset password',
    btn_salvando: 'Saving...',
    sucesso: 'Password reset successfully!',
    sucesso_titulo: 'All done!',
    sucesso_redirect: 'Redirecting to login...',
    erro_token: 'Invalid reset token',
    erro_curta: 'Password must be at least 6 characters long',
    erro_diferente: 'Passwords do not match',
    erro_generico: 'Error resetting password. The link may have expired.',
    erro_sem_token: 'Invalid or missing reset link. Request a new one.',
    voltar_login: 'Back to login',
  },

  creditos: {
    titulo: 'Add-on Credits',
    subtitulo: 'Top up your plan limits without needing to upgrade.',
    carregando: 'Loading...',
    freemium_titulo: 'Freemium plan does not include add-on credits',
    freemium_texto: 'Add-on credits are available for Starter, Pro and Enterprise subscribers. Upgrade your plan to unlock this feature.',
    ver_planos: 'See plans',
    por_pack: '/pack',
    btn_comprar: 'Buy — R$ {preco}',
    rodape: '🔒 Secure payment via Stripe or PIX · Credits valid until end of current month · No automatic recurrence',
    modal_titulo: 'Complete purchase',
    escolha_metodo: 'How would you like to pay?',
    pix_titulo: 'PIX',
    pix_sub: 'Instant, no extra fees',
    cartao_titulo: 'Credit card',
    cartao_sub: 'Debit or credit (Stripe)',
    voltar: 'Back',
    label_cartao: 'Card details',
    btn_pagar: 'Pay R$ {preco}.00',
    btn_processando: 'Processing...',
    modal_rodape: '🔒 Secure payment · No automatic recurrence',
    pix_gerando: 'Generating QR Code...',
    pix_instrucao: 'Scan the QR Code below in your banking app or copy the PIX code.',
    pix_aguardando: 'Waiting for payment confirmation...',
    pix_confirmado: 'Payment confirmed! Credits will be available shortly.',
    copiar: 'Copy',
    copiado: 'Copied!',
    toast_pack_adquirido: 'Pack "{nome}" purchased! Credits are now available.',
    toast_pix_pago: 'PIX payment confirmed! Credits added.',
    toast_erro_iniciar: 'Error starting payment',
    pack_disparos_nome: 'Sends Pack',
    pack_disparos_descricao: '+1,000 extra sends',
    pack_disparos_item1: '1,000 additional sends',
    pack_disparos_item2: 'Stack with your plan sends',
    pack_disparos_item3: 'Used after the monthly limit',
    pack_disparos_item4: 'Valid until the end of the current month',
    pack_ia_nome: 'AI Pack',
    pack_ia_descricao: '+100 AI Assistant messages',
    pack_ia_item1: '100 extra AI Assistant msgs',
    pack_ia_item2: 'Stack with your plan',
    pack_ia_item3: 'Used after the monthly limit',
    pack_ia_item4: 'Valid until the end of the current month',
  },

  admin: {
    titulo: 'Admin Panel',
    subtitulo: 'Manage customers, plans and test accounts.',
    carregando: 'Loading...',
    btn_criar_usuario: '+ Create user',
    stat_total_clientes: 'Total customers',
    stat_clientes_ativos: 'Active customers',
    stat_aguardando: 'Awaiting payment',
    stat_total_disparos: 'Total sends',
    stat_total_campanhas: 'Total campaigns',
    stat_total_contatos: 'Total contacts',
    status_ativo: 'Active',
    status_pendente: 'Pending',
    status_suspenso: 'Suspended',
    col_empresa: 'Company',
    col_email: 'Email',
    col_telefone: 'Phone',
    col_plano: 'Plan',
    col_status: 'Status',
    col_campanhas: 'Campaigns',
    col_contatos: 'Contacts',
    col_cadastro: 'Registered',
    col_ultimo_acesso: 'Last login',
    col_vencimento: 'Expires',
    col_acoes: 'Actions',
    clientes: 'Customers ({n})',
    btn_gerenciar: 'Manage',
    btn_ativar: 'Activate',
    btn_reativar: 'Reactivate',
    btn_suspender: 'Suspend',
    btn_deletar: 'Delete',
    vazio: 'No customers registered yet',
    modal_criar_titulo: 'Create user',
    label_nome_empresa: 'Company name',
    label_nome_responsavel: 'Contact name',
    label_email: 'Email',
    label_segmento: 'Segment',
    placeholder_nome_empresa: 'e.g.: John\'s Store',
    placeholder_nome_responsavel: 'e.g.: John Smith',
    placeholder_email: 'john@email.com',
    placeholder_segmento: 'e.g.: E-commerce, Healthcare...',
    label_plano: 'Plan',
    label_dias_validade: 'Days valid',
    btn_criar: '✓ Create user',
    btn_criando: 'Creating...',
    btn_cancelar: 'Cancel',
    btn_fechar: 'Close',
    resultado_titulo: '✅ Account created successfully!',
    resultado_email: 'Email',
    resultado_senha: 'Temporary password',
    resultado_plano: 'Plan',
    resultado_vencimento: 'Expires',
    resultado_aviso: '⚠️ Save the credentials now — the password will not be shown again.',
    btn_copiar_creds: '📋 Copy credentials',
    toast_copiado: 'Credentials copied!',
    toast_criado: 'Account created successfully!',
    toast_erro_criar: 'Error creating account',
    toast_campos: 'Fill in all fields',
    modal_gerenciar: 'Manage — {nome}',
    label_periodo: 'Period',
    periodo_mensal: 'Monthly',
    periodo_anual: 'Annual',
    periodo_teste: 'Trial',
    stat_envios: 'Sends',
    stat_email_admin: 'Admin email',
    btn_salvar_plano: 'Save plan',
    sec_estender: '📅 Extend validity',
    btn_aplicar: 'Apply',
    btn_salvando: 'Saving...',
    vencimento_atual: 'Current expiration:',
    sec_senha: '🔑 Reset password',
    senha_resetada: '✅ Password reset!',
    btn_copiar: '📋 Copy credentials',
    btn_gerar_senha: '🔑 Generate new random password',
    btn_gerando: 'Generating...',
    senha_aviso: 'The current password is invalidated immediately.',
    sec_overrides: '⚙️ Individual limit overrides',
    override_aviso: 'Leave blank to use the plan limit.',
    label_instancias: 'Instances',
    label_disparos_mes: 'Sends/month',
    label_ia_mes: 'AI msgs/month',
    placeholder_padrao: 'Plan default',
    btn_salvar_overrides: 'Save overrides',
    sec_creditos: '🎁 Grant add-on credits',
    creditos_aviso: 'Credits expire at the end of the current month.',
    tipo_disparos: 'Sends',
    tipo_ia: 'AI messages',
    placeholder_qtd: 'Qty',
    placeholder_desc_credito: 'Description (optional)',
    btn_conceder: 'Grant credits',
    toast_overrides: 'Overrides saved',
    toast_overrides_erro: 'Error saving overrides',
    toast_creditos: '{n} {tipo} credits granted!',
    toast_creditos_qtd: 'Enter the quantity',
    toast_creditos_erro: 'Error granting credits',
    toast_ativado: 'Tenant activated!',
    toast_ativar_erro: 'Error activating',
    confirm_suspender: 'Suspend "{nome}"?',
    toast_suspenso: 'Tenant suspended',
    toast_suspender_erro: 'Error suspending',
    toast_plano_atualizado: 'Plan updated!',
    toast_plano_erro: 'Error changing plan',
    confirm_resetar: 'Generate a new random password for this customer?',
    toast_resetar_erro: 'Error resetting password',
    toast_estendido: 'Validity extended to {data}',
    toast_estender_erro: 'Error extending validity',
    confirm_deletar: 'Permanently delete "{nome}"? All data will be lost.',
    toast_deletado: 'Tenant deleted',
    toast_deletar_erro: 'Error deleting',
    auditoria_titulo: 'Audit — campaigns with wrong instance',
    auditoria_verificar: 'Check',
    auditoria_atualizar: 'Refresh',
    auditoria_vazio_info: 'Click "Check" to list campaigns that were sent using another tenant\'s instance.',
    auditoria_ok: '✅ No campaigns with wrong instance found.',
    col_campanha: 'Campaign',
    col_empresa_dona: 'Owner company',
    col_instancia_errada: 'Current instance (wrong)',
    col_dono_instancia: 'Current instance owner',
    col_enviados: 'Sent',
    col_nova_instancia: 'New instance',
    sem_instancia_disponivel: 'No instance available',
    selecionar_placeholder: 'Select...',
    btn_reatribuir: 'Reassign',
    toast_reatribuido: 'Instance reassigned to "{nome}"',
    toast_reatribuir_erro: 'Error reassigning',
    toast_select_instancia: 'Select an instance',
    toast_erro_auditoria: 'Error loading audit',
    toast_erro_dashboard: 'Error loading admin panel',
    skeleton_empresa: 'Company',
    skeleton_cadastro: 'Registered',
    skeleton_acoes: 'Actions',
  },

  configuracao_ia: {
    titulo: 'AI Concierge',
    subtitulo: 'Configure your virtual assistant to reply automatically on WhatsApp.',
    label_instancia: 'Instance',
    sem_instancia: 'You don\'t have any WhatsApp instances yet. Create one in the WhatsApp tab first.',
    quota_sem_plano: '⚠️ Plan {plano} does not include the AI Concierge',
    quota_upgrade: 'Upgrade to the Pro plan (500 msgs/month) or Enterprise (2,000 msgs/month) to enable.',
    uso_mes: 'Usage this month ({mes})',
    uso_mensagens: '{usado} / {limite} messages',
    toggle_titulo: 'Automatic replies',
    toggle_ativo: 'AI active — replying to incoming messages',
    toggle_inativo: 'AI disabled',
    sec_secretaria: 'AI Concierge',
    sec_secretaria_desc: 'Answer the questions below and AI will create a personalized assistant for your business.',
    configurada: 'Concierge configured',
    btn_reconfigurar: 'Reconfigure',
    step1: '1. What type of business do you have?',
    step2: '2. How should your concierge communicate?',
    step3: '3. Configure your concierge',
    label_nome_secretaria: 'What is your assistant\'s name?',
    placeholder_nome_secretaria: 'e.g. Julia, Sofia, Ana',
    hint_nome_secretaria: 'The AI will use this name to introduce itself in conversations.',
    label_objetivo_conversa: 'What is the main goal of your concierge?',
    obj_agendar_nome: 'Schedule appointments / visits',
    obj_agendar_desc: 'Collects data and books via WhatsApp',
    obj_qualificar_nome: 'Understand the case',
    obj_qualificar_desc: 'Gathers interest and passes it to the front desk',
    obj_vender_nome: 'Close sales',
    obj_vender_desc: 'Guides the customer to a purchase decision',
    obj_informar_nome: 'Answer questions',
    obj_informar_desc: 'Answers about products, services and prices',
    label_descricao_negocio: 'Describe your business in 1 or 2 sentences',
    placeholder_descricao_negocio: 'e.g. Dental clinic specializing in orthodontics and cosmetic dentistry for adults and children.',
    label_publico_alvo: 'Who is your typical customer?',
    placeholder_publico_alvo: 'e.g. Adults aged 25–50 looking for cosmetic dental treatment and frustrated with other dentists.',
    label_dados_coletar: 'What should your concierge know about the patient before forwarding?',
    hint_dados_coletar: 'The qualification funnel will be built based on these fields — check them in the order you want to ask.',
    dado_nome: 'Full name',
    dado_telefone: 'Contact phone',
    dado_email: 'Email',
    dado_cidade: 'City / Neighborhood',
    dado_servico: 'Service or product of interest',
    dado_orcamento: 'Available budget',
    dado_data: 'Preferred date / time',
    dado_empresa: 'Company / Tax ID',
    dado_quantidade: 'Number of people or students',
    label_objetivo: 'What is the goal of your business?',
    label_servicos: 'What services or products do you offer?',
    label_horario: 'Business hours',
    label_contato: 'How do customers book or get in touch?',
    label_pagamento: 'Accepted payment methods',
    label_profissional: 'Featured professional or specialist',
    label_diferencial: 'What is your business\'s biggest differentiator?',
    label_restricoes: 'Restrictions or important information',
    label_localizacao: 'City and neighborhood',
    label_cursos: 'Do you offer courses or training?',
    opcional: '(optional)',
    placeholder_objetivo: 'e.g.: We are a dental clinic specialized in...',
    placeholder_servicos: 'e.g. Braces, teeth whitening, implants, cleaning...',
    placeholder_horario: 'e.g.: Mon-Fri 8am-6pm, Sat 8am-12pm',
    placeholder_profissional: 'e.g.: Dr. Ana, 15 years of experience in...',
    placeholder_diferencial: 'What sets you apart from competitors...',
    placeholder_restricoes: 'e.g.: Private only, no insurance. Free parking...',
    placeholder_localizacao: 'e.g.: New York, Brooklyn',
    placeholder_cursos: 'Describe the courses...',
    btn_gerar: '✨ Configure Concierge with AI',
    btn_gerando: 'Generating configuration...',
    toast_ia_ativada: 'AI activated',
    toast_ia_desativada: 'AI deactivated',
    toast_configurada: 'Concierge configured successfully!',
    toast_erro_gerar: 'Error generating configuration',
    toast_salvo: 'Configuration saved',
    conflito_titulo: 'Parts of this configuration may conflict with the system\'s fixed rules:',
    conflito_confirm: 'This configuration may conflict with the system\'s Absolute Rules, which take priority:',
    conflito_confirm_pergunta: 'Save anyway?',
    toast_erro_salvar: 'Error saving',
    toast_erro_diagnostico: 'Diagnostic error',
    toast_erro_testar: 'Error testing AI',
    erro_tipo_negocio: 'Select the business type',
    erro_estilo: 'Select your concierge\'s communication style',
    erro_objetivo: 'Select the main conversation objective',
    erro_descricao: 'Please describe your business (required field)',
    avancado_titulo: '⚙️ Advanced mode (manual editing)',
    avancado_bloqueado_titulo: 'Advanced mode unlocked on request',
    avancado_bloqueado_desc: 'Manually editing persona, knowledge base and funnel requires prompt-engineering knowledge. To avoid configurations that hurt your AI secretary, this mode is unlocked by request — our team validates your setup before granting access.',
    avancado_btn_solicitar: 'Request advanced mode access',
    avancado_email_assunto: 'Access request — AI Advanced mode',
    avancado_email_corpo: 'Hi, I would like to unlock the AI Concierge advanced configuration mode on my account. Account email: ',
    label_persona: 'Persona / tone instructions',
    label_conhecimento: 'Knowledge base — what your AI knows about the business',
    label_funil: 'Qualification funnel — what your AI needs to find out',
    label_delay: 'Delay before replying ({s}s)',
    delay_recomendado: 'Recommended: 8s (general), 12–15s (healthcare/legal), 0s for immediate reply.',
    label_pausa_horas: 'Pause when taking over (hours)',
    btn_salvar_avancado: 'Save technical configuration',
    btn_salvando: 'Saving...',
    btn_diagnostico: 'Diagnostic',
    diag_titulo: 'Diagnostic',
    diag_ok: 'All good — AI should be replying.',
    diag_ultimas: 'Last {n} messages logged',
    teste_titulo: 'Test AI',
    teste_desc: 'Simulates a question using the current persona and knowledge base (without sending via WhatsApp).',
    placeholder_teste: 'e.g.: What are your business hours?',
    btn_testar: 'Test',
    btn_testando: 'Testing...',
    resposta_vazia: '(empty response)',
    tipo_saude_nome: 'Healthcare & Clinics',
    tipo_saude_desc: 'Doctors, dentists, clinics',
    tipo_beleza_nome: 'Beauty & Aesthetics',
    tipo_beleza_desc: 'Salon, barbershop, aesthetics',
    tipo_alimentacao_nome: 'Food',
    tipo_alimentacao_desc: 'Restaurant, delivery, café',
    tipo_educacao_nome: 'Education & Courses',
    tipo_educacao_desc: 'School, courses, training',
    tipo_comercio_nome: 'Retail',
    tipo_comercio_desc: 'Store, retail, e-commerce',
    tipo_servicos_nome: 'Services',
    tipo_servicos_desc: 'Maintenance, consulting, renovations',
    tipo_imoveis_nome: 'Real Estate',
    tipo_imoveis_desc: 'Real estate, rental, sales',
    tipo_juridico_nome: 'Legal & Financial',
    tipo_juridico_desc: 'Law, accounting, insurance',
    tipo_outro_nome: 'Other',
    tipo_outro_desc: 'My business is not listed',
    estilo_humana_nome: 'Human',
    estilo_humana_desc: 'Empathetic, close, uses the customer\'s name',
    estilo_direta_nome: 'Direct',
    estilo_direta_desc: 'Gets to the point, short and objective replies',
    estilo_persuasiva_nome: 'Persuasive',
    estilo_persuasiva_desc: 'Focuses on conversion, highlights benefits and creates urgency',
    estilo_profissional_nome: 'Professional',
    estilo_profissional_desc: 'Corporate tone, structured and formal language',
    estilo_descontraida_nome: 'Casual',
    estilo_descontraida_desc: 'Casual, friendly, uses emojis naturally',
    label_tratamento: 'How to address the customer',
    tratamento_voce_nome: 'Informal',
    tratamento_voce_desc: 'Direct, closer tone',
    tratamento_senhor_nome: 'Sir / Madam',
    tratamento_senhor_desc: 'Formal, respectful tone',
    opcao_contato_whatsapp: 'WhatsApp',
    opcao_contato_telefone: 'Phone',
    opcao_contato_site: 'Website',
    opcao_contato_presencial: 'In person',
    opcao_contato_email: 'Email',
    opcao_contato_app: 'App',
    opcao_pag_dinheiro: 'Cash',
    opcao_pag_credito: 'Credit card',
    opcao_pag_debito: 'Debit card',
    opcao_pag_pix: 'PIX',
    opcao_pag_boleto: 'Boleto',
    opcao_pag_convenio: 'Plan/Insurance',
    opcao_pag_parcelamento: 'In-house installments',
    notif_titulo: 'Automatic patient notification',
    notif_desc: 'When the AI collects the fields configured below, it will automatically send a message to the chosen number (e.g. scheduling line, secretary, sales).',
    notif_ativar: 'Enable automatic notification',
    notif_telefone: 'Number that will receive the notifications',
    notif_telefone_ph: 'Ex: 15551234567',
    notif_telefone_ajuda: 'Include country and area code. Digits only.',
    notif_campos: 'Fields that must be collected before notifying',
    notif_campo_nome: 'Full name',
    notif_campo_cpf: 'ID / CPF',
    notif_campo_email: 'Email',
    notif_campo_contato: 'Contact phone',
    notif_campo_data: 'Appointment date',
    notif_campo_horario: 'Appointment time',
    btn_salvar_notif: 'Save notification',
    agenda_titulo: 'Calendar Integration',
    agenda_desc: 'When the AI confirms an appointment with the client (date and time agreed), it automatically creates the event in your calendar.',
    agenda_provedor: 'Calendar provider',
    agenda_prov_nenhum: 'None',
    agenda_selecione_provedor: 'Select a provider to configure the integration.',
    agenda_google_desc: 'Authorize access to your Google account to create events automatically. GOOGLE_CLIENT_ID must be configured on the server.',
    agenda_google_autorizar: 'Authorize with Google',
    agenda_google_conectado: 'Google Calendar connected successfully!',
    agenda_google_desconectado: 'Google Calendar disconnected',
    agenda_google_conectado_badge: 'Google account connected',
    agenda_google_desconectar: 'Disconnect',
    agenda_google_erro_auth: 'Error starting Google authorization',
    agenda_google_calendar_id: 'Calendar ID',
    agenda_google_calendar_id_ajuda: 'Use "primary" for the main calendar or a specific calendar ID.',
    agenda_icloud_desc: 'Enter your Apple credentials to create events via CalDAV. For security, Apple requires an app-specific password — your normal password will not work here.',
    agenda_icloud_passos_titulo: 'How to connect (takes 1 minute):',
    agenda_icloud_passo1: 'Go to appleid.apple.com and sign in with your Apple ID.',
    agenda_icloud_passo2: 'Under "Sign-In and Security", open "App-Specific Passwords" and click "Generate a password". Name it "RIIA" and copy the password shown.',
    agenda_icloud_passo3: 'Paste your Apple ID and the generated password into the fields below. Leave the URL field blank.',
    agenda_icloud_passo4: 'Click "Test connection" — your calendar URL is detected automatically.',
    agenda_icloud_username: 'Apple ID (email)',
    agenda_icloud_password: 'App-specific password',
    agenda_icloud_password_ph: 'Generated at appleid.apple.com',
    agenda_icloud_url: 'CalDAV calendar URL (optional)',
    agenda_icloud_url_ajuda: 'Leave blank — the URL is detected automatically when you test the connection.',
    agenda_icloud_url_auto: 'Auto-detected',
    agenda_dias: 'Days available for scheduling',
    agenda_dom: 'Sun', agenda_seg: 'Mon', agenda_ter: 'Tue',
    agenda_qua: 'Wed', agenda_qui: 'Thu', agenda_sex: 'Fri', agenda_sab: 'Sat',
    agenda_hora_inicio: 'Start time',
    agenda_hora_fim: 'End time',
    agenda_duracao: 'Default duration',
    agenda_timezone: 'Timezone',
    agenda_ativar: 'Enable automatic event creation',
    agenda_confirmacao_ativar: 'This instance sends calendar confirmations and reminders',
    agenda_confirmacao_ajuda: 'Uncheck on secondary instances that share the same calendar (e.g. same Simples Dental) to avoid duplicate messages to the patient. Keep it checked on only one instance per calendar.',
    credencial_revelar: 'Reveal stored value',
    credencial_revelando: 'Revealing...',
    credencial_ocultar: 'Hide',
    credencial_copiar: 'Copy',
    credencial_copiada: 'Credential copied',
    credencial_copiar_falhou: 'Could not copy',
    credencial_vazia: '(never set)',
    credencial_aviso: 'Confidential value. This access is recorded in the audit trail.',
    lembretes_titulo: 'Automatic reminders',
    lembretes_ajuda: 'Choose how far in advance to notify the client. Each row sends one message. With no rows, the default reminders stay in place (1 day and 2 hours before).',
    lembretes_add: 'Add reminder',
    lembretes_antes: 'before',
    lembretes_dias: 'days',
    lembretes_horas: 'hours',
    lembretes_confirma: 'Ask to confirm attendance',
    lembretes_confirma_ajuda: 'Tick the ones where the AI should ask "can I confirm your attendance?". The others are notices only. On Google Calendar and iCloud the answer is recorded here, since those calendars have no confirmation field.',
    lembretes_janela: 'Sending window — no reminder goes out outside these hours, in the calendar timezone.',
    lembretes_conflito: 'This instance is set to NOT send confirmations/reminders (option above). With lead times configured here, the legacy sender also stops covering this instance — result: no reminder goes out. Tick the option above, or configure the lead times on the other instance sharing this calendar.',
    lembretes_diag: 'Reminder diagnostics',
    lembretes_diag_rodando: 'Checking…',
    diag_timeout: 'The diagnostic took too long to answer. That is time, not necessarily a fault: your system may be slow right now. Try again in a few minutes.',
    diag_rede: 'Could not reach the server to run the diagnostic. Check your connection and try again.',
    lembretes_diag_erro: 'Failed to run reminder diagnostics',
    reativacao_titulo: "Win back clients who stopped coming",
    reativacao_desc: "Once an hour, RIIA reads the calendar in your system, finds who has not shown up in a while and sends ONE message. Whoever replies lands in the concierge, who books the slot. Off by default — nothing is sent until you tick this box.",
    reativacao_dias_label: "Away for",
    reativacao_dias_hint: "days or more (7 to 60 — the cap comes from how far back your calendar reaches)",
    reativacao_texto_label: "Message (optional)",
    reativacao_texto_ph: "Hi {nome}! It has been a while since we saw you 😊 Want me to find you a slot this week?",
    reativacao_texto_hint: 'Use {nome} for the client\'s first name. Write ONE MESSAGE PER LINE to vary them — one goes out per send, and never the same one twice in a row. Leave blank to use our 5 default variations.',
    reativacao_diag: "Win-back diagnostic",
    reativacao_diag_rodando: "Checking...",
    reativacao_diag_erro: "Could not run the win-back diagnostic",
    reativacao_previa: "Who would go out this cycle:",
    pos_atend_titulo: 'Thank customers after the visit',
    pos_atend_desc: 'After the appointment, the concierge sends a thank-you message — and asks for a review if you want. Replies land in this conversation as usual.',
    pos_atend_horas_label: 'Send',
    pos_atend_horas_hint: 'hours after the appointment starts (1 to 48)',
    pos_atend_texto_label: 'Message (optional)',
    pos_atend_texto_ph: 'Hi {nome}! Just saying thanks for your visit {quando} 😊',
    pos_atend_texto_hint: 'Use {nome} for the client’s first name and {quando} for the day of the visit (it becomes “today”, “yesterday” or the weekday — the message usually goes out the next day). Write ONE MESSAGE PER LINE to vary them — one goes out per send, and never the same one twice in a row. Leave blank to use our 5 default variations.',
    pos_atend_avaliacao: 'Ask for a review in the same message',
    pos_atend_link_ph: 'https://g.page/your-business/review',
    pos_atend_link_hint: 'Review link (Google, Instagram…). Without a link, we ask for feedback right here on WhatsApp.',
    pos_atend_diag: 'Post-visit diagnostics',
    pos_atend_diag_rodando: 'Checking…',
    pos_atend_diag_erro: 'Could not run diagnostics',
    pos_atend_previa: 'Who would be messaged this cycle:',
    pos_atend_com_avaliacao: 'with review request',
    pos_atend_avaliacao_hint: 'The review request is only sent in each client\'s FIRST follow-up message. Clients who already got it are still thanked, but without the request or the link.',
    espera_titulo: 'Notify when a slot opens (waiting list)',
    espera_desc: 'When a customer asks for a day that is full, the concierge keeps the request. If a slot opens on that day, it offers it — without promising, since someone else may take it first.',
    espera_texto_label: 'Message (optional)',
    espera_texto_ph: 'Hi {nome}! A slot just opened {quando} 😊 Want me to book it for you?',
    espera_texto_hint: 'Use {nome} for the first name and {quando} for the slot that opened.',
    espera_diag: 'Waiting-list diagnostics',
    espera_diag_rodando: 'Checking…',
    espera_diag_erro: 'Could not run diagnostics',
    espera_previa: 'Who is in the queue:',
    reativacao_sem_voltar: "away for {dias} days",
    lembretes_janela_de: 'Send from',
    lembretes_janela_ate: 'to',
    lembretes_remover: 'Remove',
    btn_salvar_agenda: 'Save calendar',
    agenda_testar: 'Test connection',
    agenda_testando: 'Testing...',
    agenda_toast_salvo: 'Calendar settings saved!',
    confirmar_desativar_integracao: 'Disable this integration? The concierge will stop checking availability and booking through it. Saved credentials will be removed.',
    agenda_toast_conexao_ok: 'Calendar connection OK!',
    agenda_toast_conexao_erro: 'Calendar connection failed',
  },

  conversas: {
    titulo: 'Conversations',
    subtitulo: 'Conversation history and automatic AI replies. AI replies independently of this screen — as long as the configuration is saved and enabled for each instance.',
    btn_debug: '🔍 Debug',
    btn_atualizar: 'Refresh',
    debug_titulo: 'Webhook Diagnostic',
    debug_config_titulo: 'Current configuration in Evolution',
    debug_config_select: 'Select an instance tab to see its webhook config.',
    debug_ultimos: 'Last {n} webhooks received (most recent first)',
    debug_sem_webhook: '⚠ No webhooks received since the last server restart. If you just sent a message and nothing appears here, Evolution is NOT able to deliver webhooks to the backend (wrong URL, instance without webhook configured, or network error).',
    abas_todas: 'All',
    todas_instancias: 'All instances',
    aba_instancia: 'Instance: {nome}',
    busca_placeholder: 'Search name or phone',
    sem_conversas: 'No conversations yet.',
    webhook_aviso_titulo: '⚠ No messages on this instance?',
    webhook_aviso_texto: 'The webhook may not be configured in Evolution API for "{instancia}". Click below to register it automatically.',
    btn_configurar_webhook: 'Configure webhook now',
    badge_humano: 'Human',
    badge_ia_ativa: 'AI active',
    badge_pendente: 'Awaiting team',
    badge_insatisfeito: 'Unhappy customer',
    badge_followup: 'Follow-up sent',
    badge_admin_grupo: 'Group admin',
    badge_ia_no_grupo: 'AI active in group',
    btn_ativar_ia_grupo: 'Enable AI in group',
    btn_desativar_ia_grupo: 'Disable AI in group',
    toast_ia_grupo_ativada: 'AI authorized to reply in this group',
    toast_ia_grupo_desativada: 'AI disabled in this group',
    toast_err_ia_grupo: 'Error toggling AI authorization in group',
    grupo_label: 'WhatsApp Group',
    qualif_todas: 'All',
    qualif_agendados: 'Scheduled',
    qualif_aguardando: 'Pending',
    selecione_conversa: 'Select a conversation',
    btn_voltar: '← Back',
    btn_assumir: 'Take over',
    btn_retomar_ia: 'Resume AI',
    sem_mensagens: 'No messages yet',
    placeholder_mensagem: 'Type a message... (Enter to send, Shift+Enter for new line)',
    placeholder_legenda: 'Caption (optional)...',
    btn_enviar: 'Send',
    btn_enviando: 'Sending...',
    aviso_pausar: 'When you send manually, AI is paused in this conversation for the configured time.',
    toast_midia_erro: 'Could not load media',
    toast_midia_expirada: 'Media unavailable — WhatsApp files expire after a few days',
    toast_erro_conversas: 'Error loading conversations',
    toast_erro_msgs: 'Error loading messages',
    toast_pausada: 'AI paused for {horas}h',
    toast_retomada: 'AI resumed',
    toast_err_pausar: 'Error pausing AI',
    toast_err_retomar: 'Error resuming AI',
    btn_reativar_ia: 'Reactivate AI',
    toast_reativada: 'AI reactivated for this conversation',
    toast_err_reativar: 'Error reactivating AI',
    toast_err_enviar: 'Error sending',
    toast_webhook_ok: 'Webhook configured: {url}',
    toast_webhook_err: 'Error configuring webhook',
    anexo_baixar: 'Download',
    anexo_carregando: 'Loading...',
    audio_ouvir: 'Listen to voice message',
    arquivo_grande: 'File too large (max 16 MB)',
  },

  perfil: {
    titulo: 'Company profile',
    subtitulo: 'Customize your visual identity and view your subscription.',
    carregando: 'Loading...',
    sua_assinatura: 'Your subscription',
    plano_label: '{nome} plan',
    periodo_anual: 'Annual',
    periodo_mensal: 'Monthly',
    vencimento: 'Expires',
    dias_restantes: '{n} days remaining',
    status_vencida: '⚠️ Subscription expired — renew to continue',
    status_vencendo: '⚠️ Expiring soon — consider renewing',
    preview_titulo: 'Panel preview',
    preview_empresa: 'Your company',
    preview_segmento: 'Segment',
    stat_plano: 'Plan',
    stat_status: 'Status',
    stat_campanhas: 'Campaigns',
    stat_contatos: 'Contacts',
    form_titulo: 'Company information',
    label_nome_empresa: 'Company name',
    placeholder_nome_empresa: 'e.g.: Wellness Clinic',
    label_segmento: 'Segment',
    segmento_placeholder: 'Select...',
    label_logo_url: 'Logo URL',
    placeholder_logo_url: 'https://your-company.com/logo.png',
    logo_help: 'Use a public image URL',
    label_cor: 'Main panel color',
    btn_salvar: 'Save profile',
    btn_salvando: 'Saving...',
    toast_salvo: 'Profile updated!',
    toast_erro: 'Error saving',
    seg_clinica: 'Clinic / Healthcare',
    seg_imobiliaria: 'Real Estate',
    seg_educacao: 'Education',
    seg_varejo: 'Retail / E-commerce',
    seg_restaurante: 'Restaurant / Food',
    seg_beleza: 'Beauty / Aesthetics',
    seg_advocacia: 'Law / Legal',
    seg_contabilidade: 'Accounting / Finance',
    seg_tecnologia: 'Technology',
    seg_outro: 'Other',
  },
};

export default en;
